import Lookup from 'src/componentes/select2';

const PlanoContasLookup = ({ ...rest }) => (
  <Lookup
    labelKey="nome"
    valueKey="id"
    url="/PlanoContasLookup"
    clearable={true}
    {...rest}
  />
);

export default PlanoContasLookup;
